const Bancos = {
  "001": 2,
  237: 3,
  756: 0,
  104: 1,
  341: 4,
  "033": 2,
};

export default Bancos;
